const ComplaintForm = ({ formData, handleSubmit, handleChange }) => {
  return (
    <div className="form-container">
      <form
        id="complaintForm"
        onSubmit={handleSubmit}
        data-toggle="validator"
        data-focus="false"
      >
        <div className="form-group">
          <input
            type="text"
            className="form-control-input"
            id="studentName"
            name="studentName"
            value={formData.studentName}
            onChange={handleChange}
            required
          />
          <label className="label-control" htmlFor="studentName">
            Student Name
          </label>
          <div className="help-block with-errors"></div>
        </div>
        <div className="form-group">
          <input
            type="email"
            className="form-control-input"
            id="studentEmail"
            name="studentEmail"
            value={formData.studentEmail}
            onChange={handleChange}
            required
          />
          <label className="label-control" htmlFor="studentEmail">
            Student Email
          </label>
          <div className="help-block with-errors"></div>
        </div>
        <div className="form-group">
          <input
            type="text"
            className="form-control-input"
            id="studentRollNumber"
            name="studentRollNumber"
            value={formData.studentRollNumber}
            onChange={handleChange}
            required
          />
          <label className="label-control" htmlFor="studentRollNumber">
            Student Roll Number
          </label>
          <div className="help-block with-errors"></div>
        </div>
        <div className="form-group">
          <input
            type="text"
            className="form-control-input"
            id="studentPhoneNumber"
            name="studentPhoneNumber"
            value={formData.studentPhoneNumber}
            onChange={handleChange}
            required
          />
          <label className="label-control" htmlFor="studentPhoneNumber">
            Student Phone Number
          </label>
          <div className="help-block with-errors"></div>
        </div>
        <div className="form-group">
          <input
            type="text"
            className="form-control-input"
            id="studentDepartment"
            name="studentDepartment"
            value={formData.studentDepartment}
            onChange={handleChange}
            required
          />
          <label className="label-control" htmlFor="studentDepartment">
            Student Department
          </label>
          <div className="help-block with-errors"></div>
        </div>
        <div className="form-group">
          <input
            type="text"
            className="form-control-input"
            id="studentSection"
            name="studentSection"
            value={formData.studentSection}
            onChange={handleChange}
            required
          />
          <label className="label-control" htmlFor="studentSection">
            Student Section
          </label>
          <div className="help-block with-errors"></div>
        </div>
        <div className="form-group">
          <input
            type="text"
            className="form-control-input"
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
          />
          <label className="label-control" htmlFor="subject">
            Subject
          </label>
          <div className="help-block with-errors"></div>
        </div>
        <div className="form-group">
          <textarea
            className="form-control-input"
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
          <label className="label-control" htmlFor="message">
            Message
          </label>
          <div className="help-block with-errors"></div>
        </div>
        <div className="form-group checkbox">
          <input
            type="checkbox"
            id="terms"
            name="terms"
            checked={formData.terms}
            onChange={handleChange}
            required
          />
          I've read and agree to Corso's written{" "}
          <a href="privacy-policy.html">Privacy Policy</a> and{" "}
          <a href="terms-conditions.html">Terms & Conditions</a>
          <div className="help-block with-errors"></div>
        </div>
        <div className="form-group">
          <button type="submit" className="form-control-submit-button">
            Submit
          </button>
        </div>
        <div className="form-message">
          <div id="msgSubmit" className="h3 text-center hidden"></div>
        </div>
      </form>
    </div>
  );
};

export default ComplaintForm;
